import { render, staticRenderFns } from "./fromTeacher.vue?vue&type=template&id=92247622&scoped=true&"
import script from "./fromTeacher.vue?vue&type=script&lang=js&"
export * from "./fromTeacher.vue?vue&type=script&lang=js&"
import style0 from "./fromTeacher.vue?vue&type=style&index=0&id=92247622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92247622",
  null
  
)

export default component.exports